import React from "react";
import { Link } from "react-router-dom";
import Home from "./home";

export default function Lollydbank() {
  return (
    <div className="PageContent">
      <Home />
      <div className="tableDiv table-responsive content_centered colored_background push_downwards">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">LOGS NAME</th>
              <th scope="col">Description</th>
              <th scope="col">includes</th>
              <th scope="col">Balances</th>
              <th scope="col">price</th>
              <th scope="col">status</th>
              <th scope="col">Buy now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$1,111.11</td>
              <td>$100</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$1,530.33</td>
              <td>$150</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$1,950.89</td>
              <td>$190</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$2,100.42</td>
              <td>$200</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$2,603.32</td>
              <td>$250</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$2,923.74</td>
              <td>$290</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$3,000.00</td>
              <td>$300</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$3,503.42</td>
              <td>$330</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$3,974.90</td>
              <td>$350</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$4,000.43</td>
              <td>$380</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Lollydsbanklogs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$4,217.76</td>
              <td>$400</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>

            <tr className="table_last_row">
              <th scope="col">LOGS NAME</th>
              <th scope="col">Description</th>
              <th scope="col">includes</th>
              <th scope="col">Balances</th>
              <th scope="col">price</th>
              <th scope="col">status</th>
              <th scope="col">Buy now</th>
            </tr>
          </tbody>
        </table>
      </div>
      <footer className="footer">
        <p> &copy;2023 Darknetlogs Logs Shop</p>
      </footer>
    </div>
  );
}
